import { render, staticRenderFns } from "./salutation-select.vue?vue&type=template&id=7f8d4058&"
import script from "./salutation-select.vue?vue&type=script&lang=ts&"
export * from "./salutation-select.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f8d4058')) {
      api.createRecord('7f8d4058', component.options)
    } else {
      api.reload('7f8d4058', component.options)
    }
    module.hot.accept("./salutation-select.vue?vue&type=template&id=7f8d4058&", function () {
      api.rerender('7f8d4058', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/users/components/salutation-select.vue"
export default component.exports